/**
 * Utility for tracking whether the user has seen the Post-Contact Renter Profile popup.
 * Uses localStorage to persist across sessions.
 */

const STORAGE_KEY = 'hp_renter_profile_popup_shown';

/**
 * Check if the user has already seen the renter profile popup.
 * @returns true if the popup has been shown before, false otherwise
 */
export const hasSeenRenterProfilePopup = (): boolean => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return false;
  }

  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (error) {
    console.warn('Failed to check renter profile popup status:', error);
    return false;
  }
};

/**
 * Mark the renter profile popup as shown.
 * This will prevent it from showing again in future sessions.
 */
export const markRenterProfilePopupAsShown = (): void => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch (error) {
    console.warn('Failed to mark renter profile popup as shown:', error);
  }
};

/**
 * Reset the renter profile popup shown status.
 * Useful for testing or if we need to show the popup again.
 */
export const resetRenterProfilePopupStatus = (): void => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to reset renter profile popup status:', error);
  }
};
